module.exports = __webpack_public_path__ + "static/media/Rental.4659b465.png";